import { adminScreens } from "./en/admin-screens";
import { admin } from "./en/admin";
import { auth } from "./en/auth";
import { consoleShell } from "./en/console";
import { deployKnowledge } from "./en/deploy-knowledge";
import { onboarding } from "./en/onboarding";
import { billing } from "./en/billing";
import { dashboard } from "./en/dashboard";
import { engage } from "./en/engage";
import { guide } from "./en/guide";
import { knowledgeGraph } from "./en/knowledge-graph";
import { build } from "./en/build";
import { roles } from "./en/roles";
import { service } from "./en/service";
import { settings } from "./en/settings";
import { team } from "./en/team";
import { webapp } from "./en/webapp";
// M29 namespaces (WP-M29-SCHEMA1 shells; later work packages add keys).
import { agentReports } from "./en/agent-reports";
import { customerContext } from "./en/customer-context";
import { glossary } from "./en/glossary";
import { launch } from "./en/launch";
import { webappLaunch } from "./en/webapp-launch";
import { packs } from "./en/packs";
import { privacyM29 } from "./en/privacy-m29";
// M29 Phase 2 namespaces (WP-M29-SCHEMA2 shells).
import { routingLive } from "./en/routing-live";
import { segments } from "./en/segments";
import { wallboard } from "./en/wallboard";
import { webappStudio } from "./en/webapp-studio";

/** English strings. `fil` must mirror these keys exactly (enforced by test). */
export const en = {
  auth,
  onboarding,
  console: consoleShell,
  roles,
  service,
  team,
  dashboard,
  billing,
  settings,
  admin,
  adminScreens,
  deployKnowledge,
  engage,
  guide,
  knowledgeGraph,
  build,
  webapp,
  launch,
  webappLaunch,
  customerContext,
  privacyM29,
  packs,
  glossary,
  agentReports,
  routingLive,
  wallboard,
  webappStudio,
  segments,
  common: {
    retry: "Try again",
    copy: "Copy",
    copied: "Copied",
    close: "Close",
    loading: "Loading…",
    comingSoon: "Coming soon",
    backToDashboard: "Back to dashboard",
    cancel: "Cancel",
    save: "Save",
    optional: "(optional)",
    timeRange: { "7d": "7 days", "30d": "30 days", "90d": "90 days" },
    countries: {
      placeholder: "Select a country",
      search: "Search countries…",
      empty: "No country matches your search",
      loadError: "The country list couldn't load.",
    },
    timezones: {
      inCountry: "Time zones in {{country}}",
      all: "All time zones",
    },
    upload: {
      unreachable: "We couldn't reach file storage. Check your connection and try again.",
      rejected: "File storage refused the upload. Try again.",
      storageError: "File storage had a problem. Try again in a moment.",
      cancelled: "The upload was cancelled.",
      failed: "The upload didn't finish. Try again.",
      reference: "Reference: {{reference}}",
    },
  },
  shell: {
    skipToContent: "Skip to content",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    sidebar: "Sidebar",
    mainNav: "Main navigation",
    breadcrumb: "Breadcrumb",
    search: "Search or jump to…",
    searchShortcut: "Ctrl K",
    help: "Help",
    notifications: "Notifications",
    unread: "unread",
    markAllRead: "Mark all read",
    allMarkedRead: "All notifications marked as read",
    workspaces: "Workspaces",
    newWorkspace: "New workspace",
    switchWorkspace: "Switch workspace",
    activeAgent: "Active agent",
    switchAgent: "Switch agent",
    manageAgents: "Manage all agents",
    createAgent: "Create agent",
    messagesThisMonth: "Messages this month",
    resets: "Resets {{date}}",
    upgrade: "Upgrade",
    usageUnlimited: "Unlimited",
    usageUsed: "{{value}} used",
    usageLow: "Running low · {{value}} left",
    usageLimitReached: "Limit reached",
    userMenu: "Account menu",
    myProfile: "My profile",
    platformAdmin: "Platform admin (CRUD.IT)",
    tenantConsole: "View tenant console",
    logOut: "Log out",
    platformAdminBadge: "Platform Admin",
  },
  palette: {
    title: "Command palette",
    placeholder: "Jump to a page, agent, or setting…",
    empty: "No matches",
    navigate: "navigate",
    open: "open",
  },
  theme: {
    toggle: "Toggle theme",
    heading: "Theme",
    light: "Light",
    dark: "Dark",
    system: "System",
  },
  nav: {
    overview: "Overview",
    build: "Build",
    deploy: "Deploy",
    engage: "Engage",
    workspace: "Workspace",
    help: "Help",
    platform: "Platform",
    commercial: "Commercial",
    "ai-platform": "AI Platform",
    operations: "Operations",
    dashboard: "Dashboard",
    inbox: "Inbox",
    analytics: "Analytics",
    playground: "Playground",
    knowledge: "Knowledge Base",
    "knowledge-graph": "Knowledge graph",
    "agent-settings": "Agent Settings",
    actions: "Actions",
    evaluations: "Evaluations",
    "widget-studio": "Widget Studio",
    "webapp-studio": "Web App Studio",
    channels: "Channels",
    gaps: "Knowledge Gaps",
    leads: "Leads & Inquiries",
    workflows: "Workflows",
    announcements: "Announcements",
    wallboard: "Wallboard",
    service: "Service",
    tickets: "Tickets",
    organisations: "Organisations",
    contacts: "Contacts",
    assets: "Assets",
    installations: "Installations",
    visits: "Field visits",
    orders: "Orders",
    catalogue: "Catalogue",
    "service-reports": "Service reports",
    "service-settings": "Service settings",
    audiences: "Audiences & Access",
    team: "Team",
    billing: "Billing & Usage",
    settings: "Settings",
    guide: "User Guide",
    tenants: "Tenants",
    usage: "Usage & Costs",
    plans: "Plans & Pricing",
    "sales-requests": "Sales requests",
    "ai-models": "AI Providers & Models",
    system: "System Health",
    support: "Support",
    audit: "Audit Logs",
    staff: "Platform Staff",
    "platform-settings": "Platform Settings",
  },
  pages: {
    placeholderTitle: "This screen ships in a later phase",
    placeholderBody: "{{page}} is planned in the build plan. Navigation, permissions and the shell are already in place.",
    notFoundTitle: "Page not found",
    notFoundBody: "The link may be outdated, or you may not have access to this page.",
    adminDashboardTitle: "Platform dashboard",
    adminDashboardSubtitle: "CRUD.IT platform overview. Live metrics connect in a later phase.",
  },
  chat: {
    streamingSoon: "Live answers connect in the next release.",
    newChat: "New chat",
    share: "Share",
    messageLabel: "Message",
    placeholder: "Ask about admissions, fees, documents…",
    send: "Send",
    attach: "Attach file",
    voice: "Voice input",
    enterToSend: "to send",
    newLine: "new line",
    poweredBy: "Powered by {{product}}",
    disclaimer: "Answers come from official documents. Always confirm fees with the office concerned.",
    greeting: "Hi! How can I help today?",
    greetingSub: "Ask in English, Filipino or Taglish. I answer from official documents and show you the source.",
    openWidget: "Open chat",
    closeWidget: "Close chat",
    related: "Related questions",
    workflow: {
      choose: "Choose an option",
      chosen: "Your choice",
      submit: "Continue",
      skip: "Skip",
      select: "Choose…",
      required: "This field is required.",
      invalidEmail: "Enter a valid email address.",
      invalidPhone: "Enter a valid phone number, e.g. +63 917 123 4567.",
      invalidNumber: "Enter a number.",
      invalidDate: "Choose a valid date.",
      invalidOption: "Choose one of the options.",
      invalidFromServer: "That didn't look right. Please check it and try again.",
      expired: "This question has closed. Type your message to continue.",
      privacyLink: "Read the privacy notice",
      answeredWith: "You answered: {{value}}",
      typingLocked: "Choose an option above",
      replyAnswer: "Answer: {{question}}",
      replyPlaceholder: "Type your answer",
      ratingGroup: "Your rating",
      rateStar: "Rate {{n}} out of 5",
      starsOutOf: "{{n}} out of 5",
      thumbsUp: "Thumbs up",
      thumbsDown: "Thumbs down",
      ratingComment: "Anything to add? (optional)",
      ratingCommentCount: "{{used}} of {{max}} characters",
      ratingSubmit: "Submit",
      ratingSelected: "Selected: {{rating}}",
      verifyGroup: "Verify your e-mail",
      sendCode: "Send code",
      resendCode: "Resend code",
      codeWillGoTo: "We'll e-mail a 6-digit code to {{email}}.",
      codeSentTo: "We sent a code to {{email}}. Type it in the message box.",
      codeExpiresAt: "The code works until {{time}}.",
      triesLeft_one: "{{count}} try left",
      triesLeft_other: "{{count}} tries left",
      resendIn: "You can ask for a new code in {{seconds}} s.",
      resendReady: "You can ask for a new code now.",
      securityCheck: "Security check",
      securityCheckWait: "Wait for the security check to finish, then try again.",
      invalidCode: "Enter the {{length}}-digit code from the e-mail.",
      articleGroup: "Article: {{title}}",
      articleNewTab: "(opens in a new tab)",
    },
  },
} as const;

type DeepStringRecord<T> = { readonly [K in keyof T]: T[K] extends string ? string : DeepStringRecord<T[K]> };
export type Catalog = DeepStringRecord<typeof en>;
